<ln-ln-pages-armor>
  <section body class="bg-blanco sm:border-t-[1.8px] sm:border-t-beige sm:border-t-opacity-10 sm:shadow-[0_-2px_4px_rgba(0,0,0,0.05)]">
    <div class="max-w-[1440px] mx-auto flex flex-col justify-center">
    <!--      volver button for mobile -->
    <section class="mx-[36px] mb-[14px] block sm:hidden mt-[22px]">
      <button (click)="GoHome()">
        <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
      </button>

    </section>
    <div class="block sm:hidden items-center mt-[14px] border-b-[2px] opacity-40 border-b-verde"></div>
    <div class="flex-cols mx-[35px] mt-8 flex w-[350px] md:mx-auto md:w-[782px] lg:w-full">
      <div class="mx-[36px] sm:mx-[120px]">
        <!-- top components -->
        <!--      volver button-->
        <section class="hidden sm:block">
          <button
            (click)="GoHome()"
            class="mb-[34px] flex items-center transition duration-100 hover:scale-110">
            <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
            <span class="font-['Roboto'] text-base font-normal leading-9 text-cafe">{{'buttons.goBack' | transloco}}</span>
          </button>
        </section>
      </div>
    </div>

    <!-- Mensaje superior -->
    <div class="headerBanner">
      <div class="containerInner h-[227px] sm:h-[195px]">
        <div class="containerInnerTitle">
          <span class="ml-[21px] sm:ml-[65px] text-white space-y-[15px] sm:space-y-[20px]">
            <h1 class="text-base sm:text-2xl  font-normal">{{'labels.thankForSupportArtisans' | transloco}}
</h1>
            <p class="text-sm sm:text-2xl font-semibold">{{'labels.enjoyYourItems' | transloco}}</p>
          </span>
        </div>
        <div class="imagen">
          <div class="contenedor-imagen-texto">
            <img alt="Promo Image" class="imagen" [src]="imageUrl" />
          </div>
        </div>
      </div>
    </div>

    <!-- Contenedor principal -->
    <div class="mx-auto grid grid-cols-1 sm:gap-8 px-4 py-1 sm:py-6 lg:grid-cols-[568px_1fr]">
      <!--SECTION FORM-->
      <div>
        <ln-ln-form-contact (showUnSuccessfulModal)="presentUnSuccessfulModal()"></ln-ln-form-contact>
        <div id="unSuccessfulOrder">
          @if(showUnSuccessfulModal()) {
            @if (showUnSuccessfulOrderCardBottom()) {
              <div class="flex-col h-full justify-end block sm:hidden my-[20px]">
                <ln-unsuccessful-order-response-card
                  [present]="showUnSuccessfulOrderCardBottom"
                  [text]="'messages.unSuccessfulOrder' | transloco"></ln-unsuccessful-order-response-card>
              </div>

            }
          }
        </div>
      </div>


      <!--SECTION SHOPPING CART-->
      <div class="mt-[25px] sm:mt-[20vh] w-full sm:w-[530px] space-y-[14px] flex flex-col min-h-0">
        <h3 class="mb-2 font-semibold text-cafe">{{'labels.yourCart' | transloco}}:</h3>
        <div class="max-h-[751px] overflow-y-auto custom-scrollbar">
          <div class="flex flex-col gap-y-[20px] pb-[20px]">
            @for (items of cardItems(); track items) {
              <ln-purchase-completion-item-card
                class="flex justify-start"
                [product]="items"></ln-purchase-completion-item-card>
            }

          </div>

        </div>
        @if (showUnSuccessfulModal()) {
          <div class="mt-[20px] flex flex-col gap-y-[23px] sm:mt-[98px] sm:gap-y-[26px] sticky bottom-0 right-0">
            <!--                @if (showUnSuccessfulOrderCardTop()) {-->
            <!--                  <ln-unsuccessful-order-response-card-->
            <!--                    [present]="showUnSuccessfulOrderCardTop"-->
            <!--                    text="Tuvimos un inconveniente en nuestra plataforma,-->
            <!--por favor inténtalo nuevamente en unos segundos."></ln-unsuccessful-order-response-card>-->
            <!--                }-->
            @if (showUnSuccessfulOrderCardBottom()) {
              <ln-unsuccessful-order-response-card
                class="hidden sm:block"
                [present]="showUnSuccessfulOrderCardBottom"
                [text]="'messages.unSuccessfulOrder' | transloco"></ln-unsuccessful-order-response-card>
            }
          </div>
        }
      </div>

    </div>

    </div>
  </section>
</ln-ln-pages-armor>
